import { render, staticRenderFns } from "./add-pharmacy.vue?vue&type=template&id=453bacbc&scoped=true&"
import script from "./add-pharmacy.vue?vue&type=script&lang=js&"
export * from "./add-pharmacy.vue?vue&type=script&lang=js&"
import style0 from "./add-pharmacy.vue?vue&type=style&index=0&id=453bacbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453bacbc",
  null
  
)

export default component.exports